import type { ErrorObject } from '@vuelidate/core'
import { helpers, required, requiredIf } from '@vuelidate/validators'

export const getErrors = (errors: ErrorObject[]): string[] => (
	errors.map((e: ErrorObject) => e.$message as string)
)

export const normalizeDecimal = (value: string): string =>
	value.replace(',', '.')

export const toCommaDecimal = (value: string): string =>
	value.replace('.', ',')

export const isPositiveNumber = helpers.withMessage(
	'Geben Sie eine gültige positive Zahl ein',
	(value: string | undefined) => {
		if (!value) return true

		const commaToDot = normalizeDecimal(value)
		return /^\d+(\.\d+)?$/.test(commaToDot) && Number(commaToDot) > 0
	}
)

export const requiredDe = () => {
	return helpers.withMessage('Dieses Feld darf nicht leer sein', required)
}

export const requiredDeIf = (isRequired: () => boolean) => {
	return helpers.withMessage(
		'Dieses Feld darf nicht leer sein',
		requiredIf(isRequired)
	)
}

export const isNumericOrDecimal = helpers.withMessage(
	'Ungültiges Zahlenformat. Verwenden Sie einen numerischen Wert, einen Punkt oder ein Komma als Dezimaltrennzeichen.',
	(value: string | undefined) => {
		if (!value) return true // Allow empty values (required can handle non-empty validation)

		// Allow integers, decimals with dot, and decimals with comma
		const commaToDot = normalizeDecimal(value)
		return !isNaN(Number(commaToDot)) && /^-?\d+(\.\d+)?$/.test(commaToDot)
	}
)
